import React from 'react';
import { Dropdown } from 'antd';
import { DownOutlined, ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import ButtonTransparent from '../../common/UI/ButtonTransparent';
import { SCALE_ORDER, zoomedScale } from '../helpers/scales';
import styles from './header.less';

const ScaleController = (props) => {
  const { scale, onScaleChange } = props;
  const { t } = useTranslation();

  const zoomInScale = zoomedScale(scale, 1);
  const zoomOutScale = zoomedScale(scale, -1);

  const items = SCALE_ORDER.map((key) => ({ key, label: t(`gantt.scales.${key}`) }));

  return (
    <div className={styles.scale}>
      <ButtonTransparent
        title={t('gantt.zoomOut')}
        disabled={!zoomOutScale}
        onClick={() => onScaleChange(zoomOutScale)}
      >
        <ZoomOutOutlined />
      </ButtonTransparent>

      <Dropdown
        menu={{ items, selectedKeys: [scale], onClick: ({ key }) => onScaleChange(key) }}
        trigger={['click']}
        placement="bottom"
      >
        <ButtonTransparent className={styles.scaleValue} title={t('gantt.scale')}>
          <span>{t(`gantt.scales.${scale}`)}</span>
          <DownOutlined className={styles.scaleCaret} />
        </ButtonTransparent>
      </Dropdown>

      <ButtonTransparent title={t('gantt.zoomIn')} disabled={!zoomInScale} onClick={() => onScaleChange(zoomInScale)}>
        <ZoomInOutlined />
      </ButtonTransparent>
    </div>
  );
};

export default ScaleController;
